'use client';

import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { trackPageView } from '@lib/gtm';

const SyntheticPageView = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    const url = `${pathname}?${searchParams}`;
    trackPageView(url);
  }, [pathname, searchParams]);

  return null; // This component doesn't render anything
};

export default SyntheticPageView;
